import { Controller } from "stimulus";

// Guards a playlist's "Sorting" select against accidental switches: changing it away from the
// value the page loaded with (and only if the playlist actually has episodes to lose) opens a
// Block::ConfirmDialogComponent as soon as the select changes, and confirming saves immediately.
export default class extends Controller {
  static targets = ["select", "dialog", "dialogBody"];
  static values = {
    episodeCount: Number,
    labels: Object,
  };

  connect() {
    this.initialMode = this.selectTarget.value;
  }

  onSortChange() {
    const targetMode = this.selectTarget.value;
    if (targetMode === this.initialMode) {
      return;
    }

    this.dialogBodyTarget.textContent = this.copyFor(this.initialMode, targetMode);
    this.dialogController.open();
  }

  onConfirm() {
    this.dialogController.close();
    this.element.requestSubmit();
  }

  onCancel() {
    this.selectTarget.value = this.initialMode;
    this.dialogController.close();
    this.selectTarget.focus();
  }

  get dialogController() {
    return this.application.getControllerForElementAndIdentifier(this.dialogTarget, "block--confirm-dialog-component");
  }

  copyFor(fromMode, toMode) {
    const label = this.labelsValue[toMode];
    const count = this.episodeCountValue;
    const episodeWord = count === 1 ? "episode" : "episodes";

    if (toMode === "manual") {
      return `Switching to ${label} will arrange all ${count} ${episodeWord} by their current order for you to rearrange.`;
    }

    const discard = fromMode === "manual" ? " and discard your manual order" : "";
    return `Switching to ${label} will sort all ${count} ${episodeWord} by publish date${discard}.`;
  }
}
